import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { stopRadioStationAction } from '../../../../Redux/Actions/RadioStationAction';
import FloatingRadioPlayer from './FloatingRadioPlayer';

const RadioPlayerBar = () => {
    const dispatch = useDispatch();
    const { currentAudio, currentPlaying } = useSelector((state) => state.get_current_Reducers || {});
    const { currentStation } = useSelector((state) => state.get_radio_Reducers?.player || {});
    
    // Check if we're playing a radio station
    const isPlayingRadio = currentAudio?.source_type === 'RADIO' && currentPlaying;
    const radioStation = isPlayingRadio ? (currentAudio?.station_data || currentStation) : null;
    
    const handleClose = () => {
        // Stop radio playback and hide player
        dispatch(stopRadioStationAction());
    };
    
    // Only show radio player when a radio station is active
    if (!radioStation) {
        return null;
    }
    
    return (
        <FloatingRadioPlayer 
            station={radioStation}
            onClose={handleClose}
        />
    );
};

export default RadioPlayerBar;